import { publisherShareInvalidCheck } from '@App/helpers/work-entities/fields-validators'
import { OriginalPublisherModel } from '@Entities/work/original-publisher-model'

export const isValidSuggestionPublisher = (publisher: OriginalPublisherModel | undefined) => {
    if (!publisher) {
        return false
    }

    if (!publisher.ipId || !Number.isFinite(Number(publisher.ipId))) {
        return false
    }

    const administrator = publisher.administratorPublishers[0]
    if (administrator && (!administrator.ipId || !Number.isFinite(Number(administrator.ipId)))) {
        return false
    }

    const share = administrator?.publisherShare ?? publisher.publisherShare

    return !publisherShareInvalidCheck(share)
}
